<template v-if="this.user.loggedIn">
  <div>
    <b-container>
      <div class="m-3">
        <b-alert :variant="messageState" show v-if="message">
          {{ message }}
        </b-alert>
        <b-card no-body v-if="year">
          <b-tabs card>
            <b-tab title="Ziele" active>
              <b-form>
                <b-form-group>
                  <label>Jahresziel</label>
                  <b-form-select
                    v-model="year"
                    :options="form.yearOpt"
                    class="mb-1"></b-form-select>
                  <b-form-input
                    @input="changeInput('yearly')"
                    id="yearly"
                    v-model="form.goal.yearly"
                    type="number"
                    placeholder="Jahres Ziel"
                    required></b-form-input>
                  <hr />
                  <b-row>
                    <b-col>
                      <label>Januar</label>
                      <small class="ml-2">
                        {{ workingdays.jan }} Tage à
                        {{
                          Number(
                            form.goal.mothly[1] / workingdays.jan
                          ).toLocaleString("de-DE")
                        }}
                        €
                      </small>
                      <b-form-input
                        @input="changeInput('monthliy')"
                        id="jan"
                        class="m-1"
                        v-model="form.goal.mothly[1]"
                        type="number"
                        placeholder="Januar Ziel"
                        required></b-form-input>
                      <label>Februar</label>
                      <small class="ml-2">
                        {{ workingdays.feb }} Tage à
                        {{
                          Number(
                            form.goal.mothly[2] / workingdays.feb
                          ).toLocaleString("de-DE")
                        }}
                        €
                      </small>
                      <b-form-input
                        @input="changeInput('monthliy')"
                        id="feb"
                        class="m-1"
                        v-model="form.goal.mothly[2]"
                        type="number"
                        placeholder="Februar Ziel"
                        required></b-form-input>
                      <label>März</label>
                      <small class="ml-2">
                        {{ workingdays.mar }} Tage à
                        {{
                          Number(
                            form.goal.mothly[3] / workingdays.mar
                          ).toLocaleString("de-DE")
                        }}
                        €
                      </small>
                      <b-form-input
                        @input="changeInput('monthliy')"
                        id="mar"
                        class="m-1"
                        v-model="form.goal.mothly[3]"
                        type="number"
                        placeholder="März Ziel"
                        required></b-form-input>
                      <label>April</label>
                      <small class="ml-2">
                        {{ workingdays.apr }} Tage à
                        {{
                          Number(
                            form.goal.mothly[4] / workingdays.apr
                          ).toLocaleString("de-DE")
                        }}
                        €
                      </small>
                      <b-form-input
                        @input="changeInput('monthliy')"
                        id="apr"
                        class="m-1"
                        v-model="form.goal.mothly[4]"
                        type="number"
                        placeholder="April Ziel"
                        required></b-form-input>
                      <label>Mai</label>
                      <small class="ml-2">
                        {{ workingdays.may }} Tage à
                        {{
                          Number(
                            form.goal.mothly[5] / workingdays.may
                          ).toLocaleString("de-DE")
                        }}
                        €
                      </small>
                      <b-form-input
                        @input="changeInput('monthliy')"
                        id="may"
                        class="m-1"
                        v-model="form.goal.mothly[5]"
                        type="number"
                        placeholder="Mai Ziel"
                        required></b-form-input>
                      <label>Juni</label>
                      <small class="ml-2">
                        {{ workingdays.jun }} Tage à
                        {{
                          Number(
                            form.goal.mothly[6] / workingdays.jun
                          ).toLocaleString("de-DE")
                        }}
                        €
                      </small>
                      <b-form-input
                        @input="changeInput('monthliy')"
                        id="jun"
                        class="m-1"
                        v-model="form.goal.mothly[6]"
                        type="number"
                        placeholder="Juni Ziel"
                        required></b-form-input>
                    </b-col>
                    <b-col>
                      <label>Juli</label>
                      <small class="ml-2">
                        {{ workingdays.jul }} Tage à
                        {{
                          Number(
                            form.goal.mothly[7] / workingdays.jul
                          ).toLocaleString("de-DE")
                        }}
                        €
                      </small>
                      <b-form-input
                        @input="changeInput('monthliy')"
                        id="jul"
                        class="m-1"
                        v-model="form.goal.mothly[7]"
                        type="number"
                        placeholder="Juli Ziel"
                        required></b-form-input>
                      <label>August</label>
                      <small class="ml-2">
                        {{ workingdays.aug }} Tage à
                        {{
                          Number(
                            form.goal.mothly[8] / workingdays.aug
                          ).toLocaleString("de-DE")
                        }}
                        €
                      </small>
                      <b-form-input
                        @input="changeInput('monthliy')"
                        id="aug"
                        class="m-1"
                        v-model="form.goal.mothly[8]"
                        type="number"
                        placeholder="August Ziel"
                        required></b-form-input>
                      <label>September</label>
                      <small class="ml-2">
                        {{ workingdays.sep }} Tage à
                        {{
                          Number(
                            form.goal.mothly[9] / workingdays.sep
                          ).toLocaleString("de-DE")
                        }}
                        €
                      </small>
                      <b-form-input
                        @input="changeInput('monthliy')"
                        id="sep"
                        class="m-1"
                        v-model="form.goal.mothly[9]"
                        type="number"
                        placeholder="September Ziel"
                        required></b-form-input>
                      <label>Oktober</label>
                      <small class="ml-2">
                        {{ workingdays.oct }} Tage à
                        {{
                          Number(
                            form.goal.mothly[10] / workingdays.oct
                          ).toLocaleString("de-DE")
                        }}
                        €
                      </small>
                      <b-form-input
                        @input="changeInput('monthliy')"
                        id="oct"
                        class="m-1"
                        v-model="form.goal.mothly[10]"
                        type="number"
                        placeholder="Oktober Ziel"
                        required></b-form-input>
                      <label>November</label>
                      <small class="ml-2">
                        {{ workingdays.nov }} Tage à
                        {{
                          Number(
                            form.goal.mothly[11] / workingdays.nov
                          ).toLocaleString("de-DE")
                        }}
                        €
                      </small>
                      <b-form-input
                        @input="changeInput('monthliy')"
                        id="nov"
                        class="m-1"
                        v-model="form.goal.mothly[11]"
                        type="number"
                        placeholder="November Ziel"
                        required></b-form-input>
                      <label>Dezember</label>
                      <small class="ml-2">
                        {{ workingdays.dec }} Tage à
                        {{
                          Number(
                            form.goal.mothly[12] / workingdays.dec
                          ).toLocaleString("de-DE")
                        }}
                        €
                      </small>
                      <b-form-input
                        @input="changeInput('monthliy')"
                        id="dec"
                        class="m-1"
                        v-model="form.goal.mothly[12]"
                        type="number"
                        placeholder="Dezember Ziel"
                        required></b-form-input>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-button variant="primary" @click="saveGoal()">
                  Speichern
                </b-button>
              </b-form>
            </b-tab>
            <!-- <b-tab title="Geräte">
              <b-form-group>
                <div style="display: flex; gap: 1rem;">
                  <b-button v-b-modal.modal-iphones>Geräte hinzufügen</b-button>
                </div>
                <b-modal id="modal-iphones" title="Geräte hinzufügen" no-close-on-backdrop @ok="uploadDevices">
                  <b-form-file
                    v-model="csvFile"
                    accept=".txt"
                    required
                    placeholder="Wähle eine CSV-Datei aus"
                  ></b-form-file>
                </b-modal>
              </b-form-group>
              <b-table
                v-if="iPhones.length > 0"
                :items="iPhones"
                :fields="[
                  {key: 'comlineArtNo', label: 'Comline Art. Nr.', sortable: true},
                  {key: 'appleArtNo', label: 'Apple Art. Nr.', sortable: true},
                  {key: 'telekomArtNo', label: 'Telekom Art. Nr.', sortable: true},
                  {key: 'name', label: 'Gerätename', sortable: true},
                  {
                  key: 'actions',
                  label: '',
                  },
                ]"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                responsive
                striped
                hover
                bordered
                small>
                <template #cell(actions)="data">
                  <b-button size="sm" @click="deleteIphone(data.item.comlineArtNo)" variant="danger">Löschen</b-button>
                </template>
              </b-table>
            </b-tab> -->
          </b-tabs>
        </b-card>
      </div>
    </b-container>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import moment from "moment";
  import businessDaysChecker from "moment-business-days";
  import {isHoliday} from "feiertagejs";

  import {db} from "../plugins/firebase";
  import { ref, set, onValue } from "firebase/database";
  import { storage } from "../plugins/firebase";
  import { ref as storageRef, uploadBytes } from "firebase/storage";

  export default {
    name: "IncomingGoods",
    computed: {
      ...mapGetters({
        user: "user",
      }),
    },
    watch: {
      year: function (val) {
        this.workingdays = {
          jan: this.workingDays(val, "1"),
          feb: this.workingDays(val, "2"),
          mar: this.workingDays(val, "3"),
          apr: this.workingDays(val, "4"),
          may: this.workingDays(val, "5"),
          jun: this.workingDays(val, "6"),
          jul: this.workingDays(val, "7"),
          aug: this.workingDays(val, "8"),
          sep: this.workingDays(val, "9"),
          oct: this.workingDays(val, "10"),
          nov: this.workingDays(val, "11"),
          dec: this.workingDays(val, "12"),
        };
      },
    },
    data() {
      return {
        sortDesc: false,
        sortBy: "name",
        csvFile: null,
        csvData: [],
        data: undefined,
        message: null,
        messageState: null,
        year: "",
        workingdays: {},
        form: {
          yearOpt: [],
          goal: {
            yearly: 0,
            mothly: {
              1: 0,
              2: 0,
              3: 0,
              4: 0,
              5: 0,
              6: 0,
              7: 0,
              8: 0,
              9: 0,
              10: 0,
              11: 0,
              12: 0,
            },
          },
        },
        newIphone: {
          telekomArtNo: "",
          comlineArtNo: "",
          appleArtNo: "",
          name: "",
        },
        iPhones: [],
      };
    },
    methods: {
      loadData() {
        onValue(ref(db, "/settings"), async (snapshot) => {
          console.log("Settings snapshot");

          let data = snapshot.val();
          this.data = data;

          if (data?.iPhones) {
            this.iPhones = Object.keys(data.iPhones).map((key) => {
              return {
                telekomArtNo: data.iPhones[key].telekomArtNo,
                comlineArtNo: data.iPhones[key].comlineArtNo,
                appleArtNo: data.iPhones[key].appleArtNo,
                name: data.iPhones[key].name,
              };
            });
          } else {
            this.iPhones = [];
          }

          await this.createOptsForGoal();
        });
      },
      saveGoal() {
        if (!this.year) {
          this.setMessage("Alle Felder müssen ausgefüllt sein.", "error");
        } else if (!this.form.goal.yearly) {
          this.setMessage("Alle Felder müssen ausgefüllt sein.", "error");
        } else if (
          !this.form.goal.mothly[1] ||
          !this.form.goal.mothly[2] ||
          !this.form.goal.mothly[3] ||
          !this.form.goal.mothly[4] ||
          !this.form.goal.mothly[5] ||
          !this.form.goal.mothly[6] ||
          !this.form.goal.mothly[7] ||
          !this.form.goal.mothly[8] ||
          !this.form.goal.mothly[9] ||
          !this.form.goal.mothly[10] ||
          !this.form.goal.mothly[11] ||
          !this.form.goal.mothly[12]
        ) {
          this.setMessage("Alle Felder müssen ausgefüllt sein.", "error");
        } else {
          console.log("write in db");
          set(ref(db, "settings/goals/" + this.year), {
            goal: this.form.goal.yearly,
            month: {
              1: {
                goal: this.form.goal.mothly[1],
                daily: this.form.goal.mothly[1] / this.workingdays.jan,
              },
              2: {
                goal: this.form.goal.mothly[2],
                daily: this.form.goal.mothly[2] / this.workingdays.feb,
              },
              3: {
                goal: this.form.goal.mothly[3],
                daily: this.form.goal.mothly[3] / this.workingdays.mar,
              },
              4: {
                goal: this.form.goal.mothly[4],
                daily: this.form.goal.mothly[4] / this.workingdays.apr,
              },
              5: {
                goal: this.form.goal.mothly[5],
                daily: this.form.goal.mothly[5] / this.workingdays.may,
              },
              6: {
                goal: this.form.goal.mothly[6],
                daily: this.form.goal.mothly[6] / this.workingdays.jun,
              },
              7: {
                goal: this.form.goal.mothly[7],
                daily: this.form.goal.mothly[7] / this.workingdays.jul,
              },
              8: {
                goal: this.form.goal.mothly[8],
                daily: this.form.goal.mothly[8] / this.workingdays.aug,
              },
              9: {
                goal: this.form.goal.mothly[9],
                daily: this.form.goal.mothly[9] / this.workingdays.sep,
              },
              10: {
                goal: this.form.goal.mothly[10],
                daily: this.form.goal.mothly[10] / this.workingdays.oct,
              },
              11: {
                goal: this.form.goal.mothly[11],
                daily: this.form.goal.mothly[11] / this.workingdays.nov,
              },
              12: {
                goal: this.form.goal.mothly[12],
                daily: this.form.goal.mothly[12] / this.workingdays.dec,
              },
            },
          }).then(() => {
            this.setMessage("Daten erfolgreich gespeichert.", "success");
          });
        }
      },
      changeInput(changed) {
        if (changed === "yearly") {
          Object.values(this.form.goal.mothly).forEach((element, index) => {
            console.log(element);
            this.form.goal.mothly[index + 1] = this.form.goal.yearly / 12;
          });
        } else {
          this.form.goal.yearly = Object.values(this.form.goal.mothly).reduce(
            (pv, cv) => parseInt(pv) + parseInt(cv),
            0
          );
        }
      },
      createOptsForGoal() {
        moment().tz("Europe/Berlin");
        let thisYear = moment().year();
        if (this.data && this.data.goals) {
          console.log(this.data);

          let lastYearInObject = Object.keys(this.data.goals).reduce((a, b) =>
            +a > +b ? +a : +b
          );
          if (lastYearInObject < thisYear) {
            thisYear = parseInt(lastYearInObject) + 1;
          }
        }

        console.log("thisYear", thisYear);

        this.year = thisYear;
        this.form.yearOpt = [{value: thisYear, text: thisYear.toString()}];

        if (this.data && this.data.goals && this.data.goals[thisYear]) {
          this.form.goal.yearly = this.data.goals[thisYear].goal;
          if (this.data.goals[thisYear].month) {
            for (const [key, value] of Object.entries(
              this.data.goals[thisYear].month
            )) {
              this.form.goal.mothly[key] = value.goal;
            }
          }
        }
      },
      isComLineHoliday(month, day) {
        //feiertagJS fehlender  REFORMATIONSTAG
        if (month === 9 && day === 31) {
          return true;
        }

        if (month === 11 && day === 24) {
          return true;
        } else if (month === 11 && day === 31) {
          return true;
        } else {
          return false;
        }
      },
      workingDays(yearSet, monthSet) {
        let year = moment().year();
        let month = moment().month();
        console.log();
        if (yearSet) {
          year = yearSet;
        }
        if (monthSet) {
          month = monthSet - 1;
        }
        var dddate = new Date(year, month, 1);
        moment().tz("Europe/Berlin");
        const daysThisMonth = moment(dddate).daysInMonth();
        let businessDays = 0;

        for (var i = 1; i <= daysThisMonth; i++) {
          let isBusiness = businessDaysChecker(
            new Date(year, month, i)
          ).isBusinessDay();
          let isItHoliday = isHoliday(new Date(year, month, i), "SH");
          const isItComLineHoliday = this.isComLineHoliday(month, i);

          if (isBusiness && !isItHoliday && isItComLineHoliday === false) {
            businessDays++;
          }
        }
        return businessDays;
      },
      setMessage(message, state) {
        if (state === "success") {
          this.message = message;
          this.messageState = "success";
          setTimeout(() => {
            this.message = "";
          }, 50000);
        } else if (state === "error") {
          this.message = message;
          this.messageState = "danger";
          setTimeout(() => {
            this.message = "";
          }, 50000);
        }
      },
      resetForm() {
        this.form.goal = {
          yearly: "",
          mothly: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
          },
        };
      },
      /* uploadDevices() {
        if (this.csvFile) {
          const reader = new FileReader();
          reader.onload = (event) => {
            const csvData = event.target.result;
            const lines = csvData.split("\r\n");
            lines.slice(1).forEach((line) => {
              const [comlineArtNo, appleArtNo, name, telekomArtNo] = line.split("\t");
              console.log(comlineArtNo, appleArtNo, name, telekomArtNo);
              set(ref(db, "settings/iPhones/" + comlineArtNo), {
              comlineArtNo,
              appleArtNo,
              name,
              telekomArtNo,
              });
            });
            this.setMessage("Geräte erfolgreich hochgeladen.", "success");
          };
          reader.readAsText(this.csvFile);
        } else {
          this.setMessage("Bitte wählen Sie eine CSV-Datei aus.", "error");
        }
      }, */
      uploadDevices() {
        if (this.csvFile) {
          const reader = new FileReader();
          reader.onload = (event) => {
            const csvData = event.target.result;
            const lines = csvData.split("\r\n");
            const jsonData = [];

            // Konvertiere CSV-Daten in JSON
            lines.slice(1).forEach((line) => {
              const [comlineArtNo, appleArtNo, name, telekomArtNo] = line.split("\t");
              if (comlineArtNo && appleArtNo && name && telekomArtNo) {
                jsonData.push({
                  comlineArtNo,
                  appleArtNo,
                  name,
                  telekomArtNo,
                });
              }
            });

            // Erstelle eine JSON-Datei
            const jsonBlob = new Blob([JSON.stringify(jsonData, null, 2)], { type: "application/json" });
            const jsonFileName = `uploads/${this.csvFile.name.replace(/\.[^/.]+$/, "")}.json`;

            // Lade die JSON-Datei in Firebase Storage hoch
            const storageReference = storageRef(storage, jsonFileName);
            uploadBytes(storageReference, jsonBlob)
              .then((snapshot) => {
                this.setMessage("JSON-Datei erfolgreich hochgeladen.", "success");
                console.log("Uploaded JSON file:", snapshot.metadata.fullPath);
              })
              .catch((error) => {
                console.error("Fehler beim Hochladen der JSON-Datei:", error);
                this.setMessage("Fehler beim Hochladen der JSON-Datei.", "error");
              });
          };

          reader.readAsText(this.csvFile);
        } else {
          this.setMessage("Bitte wählen Sie eine Datei aus.", "error");
        }
      },
    },
    async mounted() {
      this.loadData();
    },
  };
</script>
